<div class="wrap">
  <div class="header">
    <div class="header__logo">
      <a *ngIf="urls" [href]="urls.publicUrl" id="PublicUrlLink">
        <div class="logo"></div>
      </a>
    </div>
    <div class="header__date">
      <span id="currentTime" class="msk-time"></span>
      <span class="msk-time"
        >{{ serverHoursString() }}:{{ serverMinutesString() }} МСК
      </span>
      <span id="currentDate">{{ serverDateString() }}</span>
    </div>
    <div class="header__table">
      <div class="header__column">
        <div class="header__phone">+7 (499) 653-55-00</div>
        Для Москвы и области
      </div>
      <div class="header__column">
        <div class="header__phone">8 (800) 77-55-800</div>
        Для регионов России
      </div>
      <div class="header__column header-elementblock">
        <p>
          <app-link
            *ngIf="userInfo?.organizationInfo"
            id="OrganizationViewLink"
            styleClass="ellipsis-text"
            [label]="
              userInfo.organizationInfo.fullName?.length > 25
                ? userInfo.organizationInfo.name
                : userInfo.organizationInfo.fullName
            "
            [urlType]="userInfo.isCustomer ? linkTypeEnum.URL : linkTypeEnum.NO_URL"
            [url]="urls.organizationView"
          ></app-link>
        </p>
        <p *ngIf="userInfo?.organizationInfo && userInfo?.isCustomer">ИНН: {{ userInfo.organizationInfo.inn }}</p>
        <p class="height-20 links-container">
          <app-link
            *ngIf="userInfo && userName && urls"
            id="UserViewLink"
            [label]="userName"
            [urlType]="userInfo.isCustomer ? linkTypeEnum.URL : linkTypeEnum.NO_URL"
            [url]="urls.employeeView"
          ></app-link>
          <app-link
            *ngIf="urls && userInfo?.isCustomer"
            id="PowersOfAttorneyViewLink"
            label="МЧД"
            [urlType]="linkTypeEnum.URL"
            [url]="urls.poaRegistry"
          ></app-link>
        </p>
      </div>
    </div>
    <div class="header__authorization">
      <span
        (click)="signOut()"
        id="AuthorizationLogout"
        class="header__authorization_logout"
      ></span>
      <span
        (click)="signOut()"
        id="AuthorizationLogoutText"
        class="header__authorization_logout_text"
        >Выход</span
      >
    </div>
  </div>
</div>
